import axios from "axios"
import router from "@/router/router"

export default {
	namespaced: true,
	state: {
		modules: [],
		permissions: [],
		modulePermissions: [],
		roles: [],
		custom_fields: [],
		updated: undefined,
		error: [],
		toUpdate: 0,
		subscriptions: [],
		active_subscription: undefined,
		numberOfCreatedDocuments: 0,
		numberOfCreatedProcedures: 0,
		maximum: false,

		add_subscription: false,
		deleting: false,
		restoring: false,
		img_uploaded: false,
		MAX_DOCS: 20,
		MAX_PROCEDURES: 1,
		MAX_USERS: 5
	},

	getters: {
		modules: state => state.modules,
		permissions: state => state.permissions,
		modulePermissions: state => state.modulePermissions,
		roles: state => state.roles,
		custom_fields: state => state.custom_fields,
		toUpdate: state => state.toUpdate,
		updated: state => state.updated,
		subscriptions: state => state.subscriptions,
		active_subscription: state => state.active_subscription,
		maximum: state => state.maximum,
		add_subscription: state => state.add_subscription,
		img_uploaded: state => state.img_uploaded,

		// ACTIONS MODAL
		deleting: state => state.deleting,
		restoring: state => state.restoring,

		canCreateDocuments: (state, getters, rootState, rootGetters) => {
			const { name: subscriptionName } =
				(state.active_subscription && state.active_subscription.subscription) || {}

			return (
				rootGetters["user/isSuperAdmin"] ||
				subscriptionName !== "prova gratuita" ||
				state.numberOfCreatedDocuments < state.MAX_DOCS
			)
		},

		canCreateProcedures: (state, getters, rootState, rootGetters) => {
			const { name: subscriptionName } =
				(state.active_subscription && state.active_subscription.subscription) || {}

			return (
				rootGetters["user/isSuperAdmin"] ||
				subscriptionName !== "prova gratuita" ||
				state.numberOfCreatedProcedures < state.MAX_PROCEDURES
			)
		}
	},

	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		},

		LOAD_MODULES(state, payload) {
			state.modules = payload
		},

		LOAD_ROLES(state, payload) {
			state.roles = payload
		},

		LOAD_MODULE_PERMISSIONS(state, payload) {
			state.modulePermissions = payload
		},

		UPDATE_ROLE(state, payload) {
			state.roles = payload
		},

		ADD_MODULE(state, payload) {
			state.modules.push(payload.module)
		},

		ADD_MODULE_PERMISSION(state, payload) {
			state.modulePermissions.push(payload)
		},

		CUSTOM_FIELDS(state, payload) {
			state.custom_fields = payload
		},

		UPDATE(state, payload) {
			state.updated = payload
			state.toUpdate += 1
		},

		SUBSCRIPTION(state, payload) {
			state.subscriptions = payload.subscriptions
			state.active_subscription = payload.activeSubscription
		},

		SET_CREATED_DOCUMENTS(state, number) {
			state.numberOfCreatedDocuments = number
		},

		UPDATE_CREATED_DOCUMENTS(state, numberOfAddedDocuments) {
			state.numberOfCreatedDocuments += numberOfAddedDocuments
		},

		SET_CREATED_PROCEDURES(state, number) {
			state.numberOfCreatedProcedures = number
		},

		UPDATE_CREATED_PROCEDURES(state, numberOfAddedProcedures) {
			state.numberOfCreatedProcedures += numberOfAddedProcedures
		},

		IMG_UPLOADED(state, payload) {
			state.img_uploaded = !state.img_uploaded
		}
	},

	actions: {
		async doModules({ state, commit, rootState }) {
			var array = []
			await axios
				.get(process.env.VUE_APP_API_URL + "/api/organizationmodule", {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					commit("LOAD_MODULES", res.data.modules)
					res.data.modules.forEach(async function (module) {
						await axios
							.get(process.env.VUE_APP_API_URL + "/api/modulepermissions/" + module.module.id, {
								headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
							})
							.then(res => {
								array.push({ module: module.module, permissions: res.data.result })
							})
							.catch(err => console.error(err))
					})
					commit("LOAD_MODULE_PERMISSIONS", array)
				})
				.catch(err => console.error(err))
		},

		async doRoles({ state, commit, rootState }) {
			await axios
				.get(process.env.VUE_APP_API_URL + "/api/organizationrole", {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					var roles = res.data.roles
					commit("LOAD_ROLES", res.data.roles)
				})
				.catch(err => console.error(err))
		},

		async addModulePermissionOnRole({ state, commit, rootState }, item) {
			var id_array = []
			item.module_permission.forEach(row => id_array.push(row.id))
			var payload = {
				organization_role_id: item.organization_role_id,
				module_permission_id: id_array
			}
			var result = await axios.post(process.env.VUE_APP_API_URL + "/api/rolemodulepermission/add", payload, {
				headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			})
			if (result.data) {
				var roles = state.roles
				for (let role of roles) {
					if (role.id == item.organization_role_id) {
						role.modulePermissions = role.modulePermissions.concat(item.module_permission)
						break
					}
				}
				commit("UPDATE_ROLE", roles)
				return true
			}
			return false
		},

		async addModule({ state, commit, rootState }, payload) {
			var result = undefined
			await axios
				.post(process.env.VUE_APP_API_URL + "/api/organizationmodule", payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					commit("ADD_MODULE", res.data)
					axios
						.get(process.env.VUE_APP_API_URL + "/api/modulepermissions/" + res.data.module.id, {
							headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
						})
						.then(res => {
							commit("ADD_MODULE_PERMISSION", res.data.result)
						})
						.catch(err => {
							console.error(err)
						})
					result = res.data.module
				})
				.catch(err => {
					console.error(err)
				})
			return result
		},

		async doUsers({ state, commit }, organizationId) {
			var url = organizationId ? "/" + organizationId : ""
			var array = []
			await axios
				.get(process.env.VUE_APP_API_URL + "/api/user" + url, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					array = res.data.users
					commit("mutate", { element: "maximum", value: res.data.users.length == state.MAX_USERS })
				})
				.catch(err => {
					console.error(err)
				})
			return array
		},

		async doCustomField({ state, commit }, data) {
			//TODO questa cosa è terribile per piacere sistemiamo prima o poi
			state.custom_fields = []
			var payload = {
				owner_type: "organizations",
				levels: [data.level]
			}

			await axios
				.post(process.env.VUE_APP_API_URL + "/api/customfields/organization/" + data.organization_id, payload, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("JWT")}`
					}
				})
				.then(async res => {
					res.data.forEach(item => (item.rules = item.rules ? JSON.parse(item.rules) : ""))
					var array = []
					var email = undefined
					var pec = undefined
					if (data.level == -1) {
						res.data.forEach(item => {
							if (item.name == "email") {
								email = item
							} else if (item.name == "pec") {
								pec = item
							} else {
								array.push(item)
							}
						})
						array.push(email, pec)
					} else {
						array = res.data
					}

					await commit("CUSTOM_FIELDS", array)
					return true
				})
				.catch(err => console.error(err))
		},

		updateCustomFieldImage({ state, commit }, data) {
			state.custom_fields[data.index].custom_field_value.value = data.file
		},

		saveCustomField({ state, commit, dispatch }, { id, tab }) {
			state.updated = undefined
			var data = []
			var form_datas = []
			state.custom_fields.forEach(item => {
				// VALIDATIONs
				if (item.type != "image") {
					data.push({
						id: item.custom_field_value.id,
						owner_id: id,
						owner_type: "organizations",
						value: String(
							item.rules.computed_bool ? item.custom_field_value.og : item.custom_field_value.value
						),
						custom_field_id: item.id
					})
				} else {
					var form_data = new FormData()
					form_data.append("id", item.custom_field_value.id)
					form_data.append("owner_id", id)
					form_data.append("owner_type", "organizations")
					form_data.append("value", item.custom_field_value.value)
					form_data.append("custom_field_id", item.id)
					form_data.append("organization_id", id)
					form_datas.push(form_data)
				}
			})

			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/customfieldvalues/addOrUpdate",
					{ variables: data },
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					if (res.data) {
						commit("UPDATE", "save-successful")
						// var newval = state.custom_fields
						//
						// newval.forEach(el => {
						// 		el.custom_field_value = res.data.items.find(x => x.custom_field_id == el.id)
						// })
						// commit("CUSTOM_FIELDS", newval)
						dispatch("doCustomField", { organization_id: id, level: tab - 1 })
						router.app.$store.dispatch("user/doUser")
					}
				})
				.catch(err => {
					commit("UPDATE", "save-error")
					console.error(err)
				})

			form_datas.forEach(fd => {
				axios
					.post(process.env.VUE_APP_API_URL + "/api/customfieldvalues/addOrUpdateImage", fd, {
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					})
					.then(res => {
						if (res.data) {
							commit("IMG_UPLOADED")
							router.app.$store.dispatch("user/doUser")
						}
					})
					.catch(err => {
						commit("UPDATE", "save-error")
						console.error(err)
					})
			})
		},

		organizationSubscription({ commit, dispatch, rootGetters }) {
			axios
				.post(
					`${process.env.VUE_APP_API_URL}/api/payments`,
					{},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(({ data: { array: subscriptions } }) => {
					const today = new Date()

					let activeSubscription = subscriptions.find(subscription => {
						const validFromTmp = new Date(subscription.valid_from)
						const validFrom = new Date(
							validFromTmp.getFullYear(),
							validFromTmp.getMonth(),
							validFromTmp.getDate()
						)

						const validUntilTmp = new Date(subscription.valid_until)
						const validUntil = new Date(
							validUntilTmp.getFullYear(),
							validUntilTmp.getMonth(),
							validUntilTmp.getDate()
						)

						return today > validFrom && today < validUntil
					})

					const active = !!activeSubscription
					var issuperadmin = rootGetters["user/isSuperAdmin"]
					if (!activeSubscription) {
						if (issuperadmin) {
							activeSubscription = true
						}
					}
					commit("SUBSCRIPTION", { subscriptions, active, activeSubscription })

					if (active && activeSubscription.subscription.name === "prova gratuita") {
						dispatch("setCreatedDocuments")
						dispatch("setCreatedProcedures")
					}
				})
				.catch(err => {
					console.error(err)
				})
		},

		doMutation({ commit }, payload) {
			commit("mutate", payload)
		},

		setCreatedDocuments({ commit }) {
			axios(`${process.env.VUE_APP_API_URL}/api/documents/`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("JWT")}`
				}
			})
				.then(({ data }) => commit("SET_CREATED_DOCUMENTS", data.length))
				.catch(() => {})
		},

		setCreatedProcedures({ commit }) {
			axios(`${process.env.VUE_APP_API_URL}/api/projects/count-procedures`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("JWT")}`
				}
			})
				.then(({ data }) => commit("SET_CREATED_PROCEDURES", data))
				.catch(() => {})
		}
	}
}
